var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserLike(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.148,
    height: 29.148,
    viewBox: "0 0 29.148 29.148",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "like-svgrepo-com_1_",
    "data-name": "like-svgrepo-com(1)",
    transform: "translate(-4 -4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5141",
    "data-name": "Path 5141",
    d: "M8.306,21H4.994A1.019,1.019,0,0,0,4,21.994V37.23a1.019,1.019,0,0,0,.994.994H6.65a2.658,2.658,0,0,0,2.65-2.65V21.994A1.019,1.019,0,0,0,8.306,21Z",
    transform: "translate(0 -5.738)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5142",
    "data-name": "Path 5142",
    d: "M34.549,15.924H30.574a2.658,2.658,0,0,1-2.65-2.65V6.65A2.658,2.658,0,0,0,25.275,4H23.618a1.019,1.019,0,0,0-.994.994V8.968c0,3.511-2.451,6.956-5.631,6.956a1.019,1.019,0,0,0-.994.994V30.167a.963.963,0,0,0,.927.994c4.5.2,6.028,1.987,10.732,1.987,4.968,0,9.539-.53,9.539-6.293V18.574A2.658,2.658,0,0,0,34.549,15.924Z",
    transform: "translate(-4.05)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserLike);
export default __webpack_public_path__ + "static/media/user_like.fc525b6b3891c7b48ac962421326c25c.svg";
export { ForwardRef as ReactComponent };